// @ts-nocheck
import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { handleFetchApi } from "../../../utils/api";
import { useDispatch, useSelector } from "react-redux";
import ButtonComponents from "../../commonComponents/ButtonComponents";
import { PlaidLink } from "react-plaid-link";
import { textColor } from "../../../utils/commonstyle";
import PlaidLogo from "../../../assets/plaid.png";
import { useNavigate } from "react-router-dom";
import { linkAccount } from "../../../redux/slice/accountSlice";
import { AppconfigName, getInvestorApiUrl } from "../../../utils/config";

const BankAccountLink = () => {
  const configName = AppconfigName();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userData, loginInvestorId, businessId } = useSelector(
    (state) => state.user
  );
  const { loading } = useSelector((state) => state.account);
  const [linkToken, setLinkToken] = useState(null);

  const handleButtonClick = async () => {
    const investorIdDetails = loginInvestorId ? loginInvestorId : businessId;
    try {


      // Fetch the link token from API
      const ApiResponse = await handleFetchApi({
        endpoint: "LinkToken",
        method: "POST",
        baseUrl:getInvestorApiUrl(),
        payload: {
          clientUserId: `${investorIdDetails}`,
          clientName: `${configName}`,
        },
      });
      setLinkToken(ApiResponse.data.body.link_token);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const onSuccess = async (public_token, metadata) => {
    const payload = {
      PublicToken: public_token,
      AccountId: metadata.account.id,
      AccountName: metadata.account.name,
      PlaidTokenType: "processor",
      AccountType: metadata.account.subtype,
      BankName: metadata.institution.name,
      investorId: loginInvestorId ? loginInvestorId : businessId,
      UserId: userData?.UserId,
    };

    try {
      // Dispatch the linkAccount action and wait for the response using async/await
      const response = await dispatch(linkAccount(payload));

      // Proceed with navigation once the response is received
      if (
        response.payload.statusCode === 200 ||
        response.payload.statusCode === 201
      ) {
        navigate("/kyc-kyb/account-verification/add-funds");
      }
    } catch (error) {
      console.error("Error during linkAccount dispatch:", error);
    }
  };


  useEffect(() => {
    if (!linkToken) {
      handleButtonClick();
    }
  }, []);

  return loading ? (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: 10,
      }}
    >
      {" "}
      <CircularProgress sx={{ color: "#faaf19" }} data-testid="loading-spinner" />
    </Box>
  ) : (
    <Box
      sx={{
        maxWidth: "45%",
        mx: "auto",
        my: 1.5,
        display: "flex",
        flexDirection: "column",
        minHeight: { xs: "80vh", md: "33.2rem" },
        bgcolor: "background.paper",
        p: 4,
      }}
      data-testid="bank-account-link"
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          fontSize: { xs: "1.25rem", md: "1.5rem", xl: "1.625rem" },
          color: textColor.fontColor,
          mb: 2,
          textAlign: "center",
        }}
        data-testid="link-bank-title"
      >
        Link Your Bank Account
      </Typography>
      <Typography
        textAlign="center"
        color={textColor.fontColor}
        fontWeight={400}
        fontSize={14}
        data-testid="bank-description"
      >
        xBid utilizes Plaid's secure data transfer network to connect your bank
        account to your {AppconfigName} profile for seamless, reliable fund
        management.
      </Typography>
      <Typography
        textAlign="center"
        color={textColor.fontColor}
        fontWeight={400}
        mt={2}
        fontSize={14}
        data-testid="plaid-network-description"
      >
        Plaid's extensive network covers 12000+ financial institutions.
      </Typography>
      <Box textAlign="center" data-testid="plaid-link-container">
        {linkToken ? (
          <PlaidLink
            token={linkToken}
            onSuccess={onSuccess}
            style={{ border: "none" }}
            onExit={(error, metadata) => {
              if (error) {
                console.error("Error:", error);
              }
            }}
          >
            <ButtonComponents
              label="Link Bank Account"
              variant="contained"
              sx={{
                mt: 3,
                mb: 3,
                fontSize: "14px",
                padding: "8px",
                borderRadius: "4px",
                width: "170px",
                border: "none",
                display: "inline-block",
              }}
              data-testid="link-bank-button"
            />
          </PlaidLink>
        ) : (
          <Typography
            my={3}
            fontSize={12}
            textAlign="center"
            justifyContent={"center"}
            display={"flex"}
            alignItems={"center"}
            data-testid="loading-message"
          >
            Generating link token, please wait...
          </Typography>
        )}
      </Box>
      <Typography
        sx={{
          color: textColor.fontColor,
          textAlign: "center",
          fontSize: 12,
          fontWeight: 400,
        }}
        data-testid="plaid-security-message"
      >
        You will be directed to Plaid's interface to securely connect your bank
        account. <br />
        Plaid uses industry-leading security measures to protect your
        information. <br />
        Follow the on-screen instructions to complete the process.
      </Typography>

      <Box textAlign={"center"} mt={3} data-testid="powered-by-plaid">
        <Typography variant="caption" sx={{ color: "#666" }}>
          Powered by
        </Typography>
        <div className="flex justify-center text-center mr-3">
          <img
            src={PlaidLogo}
            alt="Plaid Logo"
            style={{ height: "35px", marginLeft: "8px", textAlign: "center" }}
            data-testid="plaid-logo"
          />
        </div>
      </Box>
    </Box>
  );
};

export default BankAccountLink;
